import { render } from "./ConfigurationsPoint.vue?vue&type=template&id=2787592b"
import script from "./ConfigurationsPoint.vue?vue&type=script&lang=js"
export * from "./ConfigurationsPoint.vue?vue&type=script&lang=js"

import "./ConfigurationsPoint.vue?vue&type=style&index=0&id=2787592b&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__